import { useCallback } from 'react';

import { useTheme } from '@/shared/ui';

import useRegularOptions from '@/features/_shared/chart/hooks/options/useRegularOptions';
import { withSpotSeriesAppearance } from '@/features/_shared/chart/lib/applyChartSeriesAppearance';
import { createChartAppearance } from '@/features/_shared/chart/theme/chartAppearance';
import type {
  ExtendedOptions,
  ExtendedSeriesOptionsType
} from '@/features/_shared/chart/types/highcharts';

const useSpotOptions = (height?: number, isDhChart = false) => {
  const { createOptions: createRegularOptions } = useRegularOptions(height, isDhChart);
  const theme = useTheme();

  const createOptions = useCallback(
    (chartSeries: ExtendedSeriesOptionsType[], hiddenSeriesIds: string[] = []): ExtendedOptions => {
      const appearance = createChartAppearance(theme, 'regular');
      const coloredSeries = chartSeries.map(series => withSpotSeriesAppearance(series, appearance));
      return createRegularOptions(coloredSeries, hiddenSeriesIds);
    },
    [createRegularOptions, theme]
  );

  return { createOptions };
};

export default useSpotOptions;
